import type { RenderOptions } from '@testing-library/react';
import { render } from '@testing-library/react';
import type { PropsWithChildren, ReactNode } from 'react';

import { VarnishApp } from '../components/VarnishApp';

const VarnishAppWrapper = ({ children }: PropsWithChildren) => {
    return <VarnishApp>{children}</VarnishApp>;
};

const customRender = (ui: ReactNode, options?: Omit<RenderOptions, 'wrapper'>) =>
    render(ui, { wrapper: VarnishAppWrapper, ...options });

// re-export everything - we overwrite render with our customRender
export * from '@testing-library/react';

// override render method
export { customRender as render };
